import { apiFetch } from "../utils/apiFetch"

export type PctLookupAddress = {
  street: string
  line2: string
  postalCode: string
  city: string
  region: string
  countryCode: string | null
}

export type PctLookupApplicant = {
  name: string
  countryCode: string | null
  // Only when the EPO register knows the application and the applicant
  address?: PctLookupAddress
}

export type PctLookupResult = {
  title: string | null
  internationalFilingDate: string | null
  applicants: PctLookupApplicant[]
  // ISO 639-1 code of the language of the international publication, when the register makes it certain
  publicationLanguage: string | null
  // Office that made the international search report, e.g. EP
  searchAuthority: string | null
}

// Looks the PCT application up at the EPO (Open Patent Services)
export function lookupPctApplication(number: string) {
  return apiFetch(`/api/epo-ops/pct?number=${encodeURIComponent(number)}`) as Promise<PctLookupResult>
}
